
import React, { useState, useEffect, useContext, useRef } from "react";
import quizThumb from '../../assets/images/quiz-default.jpg';
import Footer from "../../components/footer/Footer";
import Header from "../../components/header/Header";
import { useHistory, Link, useLocation } from "react-router-dom";
import moment from "moment";
import tmdbApi from "../../api/tmdbApi";
import Modal from 'react-bootstrap/Modal';
import Select from 'react-select';
import SweetAlert from 'react-bootstrap-sweetalert';
import parse from "react-html-parser";
import { Gallery } from "react-grid-gallery";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import { contentContext } from "../../context/contentContext";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import "react-lazy-load-image-component/src/effects/blur.css";
import Loader from "../../components/loader";

const Quiz = () => {
    const transformRef = useRef(null);
    const history = useHistory();
    const { state } = useLocation();
    const { quizinfo, formData } = state || {};
    const { clientInfo, setClientInfo } = useContext(contentContext)
    const [handleBackPopup, setHandleBackPopup] = useState(false)
    const [selected, setSelected] = useState({});
    const [questions, setQuestions] = useState([]);
    const [qdisplay, setQdisplay] = useState(false);
    const [answersdata, setAnswers] = useState([]);
    const [quizData, setQuizData] = useState(null);
    const [items, setItems] = useState([]);
    const [success, setSuccess] = useState(false);
    const [imageCloudfront, setImg] = useState(false);
    // const [imageWidth, setImageWidth] = useState(window.innerWidth);
    const [deletepopup, setdeletepopup] = useState(false);
    const [resetpopup, setresetpopup] = useState(false);

    const [backButtonPressed, setBackButtonPressed] = useState(false);
    const [errorMessage, setError] = useState("");
    const [quizResult, setQuizResult] = useState({});
    const [img, setImage] = useState("")
    const [popup, setPopup] = useState(false)
    const handleClosePopup = () => setPopup(false);
    const [filteredOptions, setFilteredOptions] = useState([]);
    const [activeField, setActiveField] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const [isAutoSliding, setIsAutoSliding] = useState(false);
    const [index, setIndex] = useState(-1);
    const [gallery, setGallery] = useState([]);
    const [currentImage, setcurrentImage] = useState(null);
    const [nextIndex, setnextIndex] = useState(null);
    const [nextImage, setnextImage] = useState(null);
    const [prevIndex, setprevIndex] = useState(null);
    const [prevImage, setprevImage] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    const [isPopupOpen, setPopupOpen] = useState(false);
    const [popupImage, setPopupImage] = useState(false);
    const [isPopupLoading, setPopupLoading] = useState(false);


    useEffect(() => {
        if (!localStorage.getItem("token1")) {
            history.push("/login");
        }
    }, [])

    useEffect(() => {
        if (gallery) {
            console.log(gallery, index)
            const currentImage = gallery[index];
            setcurrentImage(currentImage)
            const nextIndex = (index + 1) % gallery.length;
            setnextIndex(nextIndex)
            const nextImage = gallery[nextIndex] || currentImage;
            setnextImage(nextImage)
            const prevIndex = (index + gallery.length - 1) % gallery.length;
            setprevIndex(prevIndex)
            const prevImage = gallery[prevIndex] || currentImage;
            setprevImage(prevImage)
        }

    }, [index]);

    useEffect(() => {
        if (currentImage) {
            const img = new Image();
            img.src = `${imageCloudfront}${currentImage?.filepath.replace(/ /g, "%20")}?auto=compress,format`;
            img.onload = () => setIsLoading(false);
        }

    }, [currentImage]);

    useEffect(() => {

        if (window.site === undefined) {
            setTimeout(() => {
                if (window.site && window.site.common && window.site.common.imageCloudfront) {
                    setImg(window.site.common.imageCloudfront)
                }
            }, 1000);
        }
        if (window.site && window.site.common && window.site.common.imageCloudfront) {
            setImg(window.site.common.imageCloudfront)
        }


    }, [window.site]);

    useEffect(() => {
        const selectedLength = Object.keys(selected).length
        if (selectedLength > 0) {
            // Add event listener for popstate to detect when the user presses the back button
            const handlePopState = (event) => {

                // Display the popup
                setHandleBackPopup(true);
                // Prevent default action of going back
                event.preventDefault();
                console.log("Browser back button pressed.");

            };

            // Initially pushState to allow popstate to fire
            window.history.pushState({}, document.title, window.location.href);

            // Add popstate listener
            window.addEventListener("popstate", handlePopState);

            return () => {
                // Cleanup event listener when component unmounts
                window.removeEventListener("popstate", handlePopState);
            };
        }

    }, [selected]);
    useEffect(() => {
        if (!localStorage.getItem("token1")) {
            history.push("/login");
        }
    }, [])
    useEffect(() => {
        // This function will handle the beforeunload event
        const handleBeforeUnload = (event) => {
            // Prevent the default browser prompt (e.g., "Changes you made may not be saved")
            event.preventDefault();
            // For most browsers to show a confirmation dialog
            event.returnValue = '';  // This triggers the native browser confirmation dialog (which we want to avoid)

            // Show custom popup instead of native browser dialog
            //   setHandleBackPopup(true);
        };

        // Add the event listener for beforeunload (when user attempts to reload/close the page)
        window.addEventListener('beforeunload', handleBeforeUnload);

        // Cleanup on component unmount
        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, []);


    useEffect(() => {
        window.scrollTo(0, 0);
        let quizinfo = JSON.parse(localStorage.getItem('q'))
        if (quizinfo) {
            setQuizData(quizinfo)
        }

    }, []);
    useEffect(() => {
        if (quizData) {
            GetQuestionsInfo(quizData)
            GetAnswersInfo()
        }

    }, [quizData]);

    const handleInputChange = (inputValue, Index) => {
        // console.log('a', inputValue)
        setActiveField(Index)
        if (inputValue != "") {
            const results = answersdata.filter(option =>
                option.answer.toLowerCase().includes(inputValue.toLowerCase())
            );
            console.log('results', results)
            setFilteredOptions(results);
        } else {
            setFilteredOptions([]);
        }

    }

    const GetAnswersInfo = async () => {
        try {
            const response = await tmdbApi.answerInfo();
            setAnswers(response?.result);
        } catch {
            console.log("error");
        }
    };

    const GetQuestionsInfo = async (quizData) => {

        try {
            let params = {
                quizid: quizData?.quizid
            }
            const response = await tmdbApi.questionInfo(params);
            if (response?.result && response?.result?.questionData.length > 0) {
                setQuestions(response?.result?.questionData);
                let itemsList = []
                response?.result?.questionData.forEach(item => {
                    itemsList.push({
                        "question": item.name,
                        "questionid": item.questionid,
                        "answer": "",
                        "answerid": "",
                        "description": item.description,
                        "images": item?.files
                    });
                });


                setItems(itemsList)

                setQdisplay(true)
            } else {
                setQuestions([]);
            }

        } catch {
            console.log("error");
        }
    };

    const handleSelectChange = (newItem, name) => {
        setSelected((prevData) => ({
            ...prevData, // Keep the other fields intact
            [name]: newItem, // Update the changed field
        }));

        // console.log('newItem ', newItem, name)
        let itemCreate = newItem.value.split("_|_")
        let objectElement = {
            "question": itemCreate[1],
            "questionid": itemCreate[2],
            "answer": newItem.label,
            "answerid": itemCreate[0],
            // "description": itemCreate[3]
        }
        setItems((prevItems) => {
            // Check if the item with the same ID exists
            const existingIndex = prevItems.findIndex(
                (item) => item.questionid === objectElement.questionid
            );

            if (existingIndex !== -1) {
                // Update the existing item
                const updatedItems = [...prevItems];
                updatedItems[existingIndex] = { ...updatedItems[existingIndex], ...objectElement };
                return updatedItems;
            }

            // Add the new item
            return [...prevItems, objectElement];
        });
    };

    const handleSubmit = async (e) => {
        // console.log('quizinfo ', quizData, formData)
        if (selected && Object.keys(selected).length == 0) {
            setError("Please answer atleast one question")
            return;
        }
        const clientid = localStorage.getItem("clientid")

        let bodyParams = {
            "quizparticipants": { name: clientInfo?.name, emailid: clientInfo?.email, },
            "quizparticipantsanswers": {},
            "clientid": clientid
        }

        bodyParams["quizparticipants"]["quizid"] = quizData?.quizid
        bodyParams["quizparticipantsanswers"]["quizid"] = quizData?.quizid
        bodyParams["quizparticipantsanswers"]["quiz"] = items
        bodyParams["quizparticipantsanswers"]["clientid"] = clientid

        let liveParticipants;

        // Debugging logs to check the actual values
        if (quizData?.quizType === "Competitive") {
            liveParticipants = false; // If status is completed and type is Competitive, set false
        } else {

            liveParticipants = true; // Default case if quizType is not 'Competitive'
        }

        let statusParam = quizData?.status == "LIVE" ? "" : "completed";

        try {
            const response = await tmdbApi.quizParticipation(bodyParams, liveParticipants, clientid);
            console.log(response);
            // if (response?.statusCode == 200) {
            setQuizResult(response?.result)
            localStorage.setItem('qr', JSON.stringify(response?.result))
            setSuccess(true);
            //  }
        } catch {
            console.log("error");
        }
    }

    const onCancel = (e) => {
        e.preventDefault()
        setdeletepopup(true)
        // history.push("/")
    };

    const onCancelConfirm = async (e) => {
        history.push("/")
    }

    const onCancelReject = (e) => {
        setdeletepopup(false)
    }

    const onResetConfirm = async (e) => {
        setresetpopup(false)
        setSelected({})
        let itemsList = []
        items.forEach(item => {
            itemsList.push({
                "question": item.question,
                "questionid": item.questionid,
                "answer": "",
                "answerid": "",
                "description": item.description
            });
        });


        setItems(itemsList)
    }
    const onBackConfirm = async () => {
        setHandleBackPopup(false);
        // setBackButtonPressed(true);

        history.push({
            pathname: "/",
            state: { flag: true }
        });
        // setPrvPageActive(true)
        window.history.pushState({}, document.title, window.location.href);
    }
    const onBackReject = () => {
        // setHandleBackPopup(false)
        setHandleBackPopup(false);
        // Use replaceState to avoid pushing a new entry in the history
        window.history.replaceState({}, document.title, window.location.href);
    }
    const onResetReject = (e) => {
        setresetpopup(false)
    }
    // useEffect(() => {
    //     const handleResize = () => {
    //       const screenWidth = window.innerWidth;

    //       // Check if it's a mobile resolution (below 1024px) and set width to 2000px
    //       if (screenWidth <= 1024) {
    //         setImageWidth(2000); // Set width to 2000px for mobile screens
    //       } 
    //     };

    //     // Listen for resize events
    //     window.addEventListener("resize", handleResize);

    //     // Cleanup event listener
    //     return () => {
    //       window.removeEventListener("resize", handleResize);
    //     };
    //   }, []);
    const handlepopup = (item) => {
        setPopup(true)
        setImage(item?.filepath)
    }


    const onReset = (e) => {
        window.scrollTo(0, 0);
        e.preventDefault()
        setresetpopup(true)
        // setSelected({})
    };

    const onConfirm = () => {
        setSuccess(false);

        if (quizData?.quizType == "Self Assessment") {
            // Redirect to the result page if the quiz type is "Competitive" and the status is "completed"
            history.push({
                pathname: "/result",
                state: { quizResult },
            });
        } else
        //if (quizData?.quizType !== "Self Assessment") 
        {
            // Redirect to thank you page if the quiz type is not "Self Assessment"
            history.push("/thankyou");
        }
        // else {
        //   // Default redirect to the result page
        //   history.push({
        //     pathname: "/result",
        //     state: { quizResult },
        //   });
        // }
    };
    const customComponents = {
        DropdownIndicator: () => null, // Remove the dropdown indicator
        IndicatorSeparator: () => null, // Optionally remove the separator
    };

    const handleClick = async (e, index, files) => {
        // console.log(index, files, 'dss')
        // console.log(e, 'eeee')

        setIndex(e)
        setIsOpen(true);
        setIsAutoSliding(true);
        setGallery(files)
    };

    const handleClose = () => {
        setIsOpen(false);
        setIsAutoSliding(false); // Stop auto-sliding when lightbox closes
        setIndex(-1)
    };

    const handleMovePrev = (e) => setIndex(prevIndex);
    const handleMoveNext = (e) => setIndex(nextIndex);

    const handleImageLoadError = (e) => {
        // console.log('ieee ', e)
    }

    const handlePopupload = (e) => {
        setPopupLoading(true)

        // setTimeout(() => {
        //     setPopupLoading(false)
        // }, 3000);
    }

    // console.log('ooo ', isOpen, currentImage)
    return (
        <main>
            <Header />
            <div className="wrapper quiz_page">
                <div className="form_block">
                    <div className="quiz_info">
                        <div className="img">
                            {quizData?.files && quizData?.files.length > 0 ?
                                <img src={imageCloudfront + quizData?.files[0]?.filepath.replace(/ /g, "%20") + `?auto=compress,format&width=125`} />
                                : <img src={quizThumb + `?auto=compress,format&width=125`} />}

                        </div>
                        <div className="left">
                            <h3>{quizData?.name}</h3>
                            <div className="date">
                                <p>{quizData?.startDate && moment(new Date(quizData?.startDate)).format('DD MMM, YYYY')}</p>
                                <span className="users"><span className="material-symbols-outlined icon"> group </span><span className="num">{quizData?.participants || 0}</span></span>
                            </div>
                        </div>
                        <div className=" border_btn" onClick={(e) => onCancel(e)}> <span className="material-symbols-outlined mr-10"> arrow_back </span>Back to Home</div>
                    </div>
                </div>
                <div className="question_block">

                    {qdisplay && questions?.length > 0 && questions.map((item, index) => {
                        return (

                            <div className="quiz_info mb-3" key={index}>
                                {/* {item?.files?.length > 0 && <div className="img" data-bs-toggle="modal"
                                    data-bs-target=".transaction-detailModal" onClick={() => handlepopup(item)}>
                                    <span className="material-symbols-outlined img_view"> zoom_out_map </span>

                                    {item?.files && item?.files.length > 0 && <img src={imageCloudfront + item?.files[0]?.filepath} />}

                                </div>} */}


                                <div className={item?.files?.length > 0 ? "content" : "no-image content"}>
                                    <p>{parse(item?.description)}</p>

                                    <h5>{item?.name}</h5>

                                    <Select className="select"
                                        isMulti={false}
                                        placeholder={"Type Answer and Select"}
                                        onChange={(e) => handleSelectChange(e, index)}
                                        onInputChange={(value) => handleInputChange(value, index)}
                                        options={filteredOptions && filteredOptions.map((eachItem) => {
                                            //const filesString = JSON.stringify(item.files); // Convert the files array to a string
                                            // return { value: `${eachItem.answerid}_|_${item?.name}_|_${item?.questionid}_|_${item?.description}_|_${filesString}`, label: eachItem.answer }

                                            return { value: `${eachItem.answerid}_|_${item?.name}_|_${item?.questionid}`, label: eachItem.answer }

                                        })}
                                        isClearable
                                        value={selected && selected[index] ? selected[index] : null}
                                        menuIsOpen={activeField === index && filteredOptions.length > 0} // Open only for the active field
                                        components={customComponents}
                                    />
                                </div>
                                <div className="img_block">

                                    {item?.files?.length > 0 && item?.files.map((file, index) => {

                                        return (

                                            <div className="img"

                                                onClick={(e) => { setPopupOpen(true); setPopupImage(imageCloudfront + file?.filepath.replace(/ /g, "%20")); handlePopupload(e) }}
                                            >
                                                <span className="material-symbols-outlined img_view"> zoom_out_map </span>

                                                {item?.files && item?.files.length > 0 && <img src={imageCloudfront + file?.filepath.replace(/ /g, "%20") + `?auto=compress,format&width=125`} />}

                                            </div>)

                                    })}



                                    {/* {item?.files?.length > 0 && <Gallery
                                        images={item?.files.map((file, index) => {

                                            return { src: `${imageCloudfront}${file?.filepath.replace(/ /g, "%20")}?auto=compress,format&width=125`, original: `${imageCloudfront}${file?.filepath.replace(/ /g, "%20")}?auto=compress,format` }

                                        })}
                                        onClick={(e) => handleClick(e, index, item?.files)}
                                        enableImageSelection={false}
                                        id="galleryFullSize" />
                                    }

                                    {isOpen && currentImage?.filepath && <Lightbox
                                        mainSrc={`${imageCloudfront}${currentImage?.filepath.replace(/ /g, "%20")}?auto=compress,format`}
                                        imageTitle={currentImage?.caption}
                                        mainSrcThumbnail={`${imageCloudfront}${currentImage?.filepath.replace(/ /g, "%20")}?auto=compress,format`}
                                        nextSrc={`${imageCloudfront}${nextImage?.filepath.replace(/ /g, "%20")}?auto=compress,format`}
                                        nextSrcThumbnail={`${imageCloudfront}${nextImage?.filepath.replace(/ /g, "%20")}?auto=compress,format`}
                                        prevSrc={`${imageCloudfront}${prevImage?.filepath.replace(/ /g, "%20")}?auto=compress,format`}
                                        prevSrcThumbnail={`${imageCloudfront}${prevImage?.filepath.replace(/ /g, "%20")}?auto=compress,format`}
                                        onCloseRequest={(e) => handleClose(e)}
                                        onMovePrevRequest={(e) => handleMovePrev(e)}
                                        onMoveNextRequest={(e) => handleMoveNext(e)}
                                        onAfterOpen={(e) => handleImageLoadError(e)}
                                        id="lightboxComponent"
                                    />} */}


                                    {/* {item?.files?.length > 0 && item?.files?.map((file, index) => (
                                        <div
                                            key={index} // Always add a unique key when rendering a list
                                            className="img"
                                            data-bs-toggle="modal"
                                            data-bs-target=".transaction-detailModal"
                                            onClick={() => handlepopup(file)} // Pass the file object to handlepopup
                                        >
                                            <img
                                                src={`${imageCloudfront}${file?.filepath}?auto=compress,format`} // Remove width parameter from URL
                                                alt={file?.name || "Image"} // Accessible alt text

                                            />
                                        </div>
                                    ))} */}
                                </div>



                            </div>
                        )
                    })}


                    {!qdisplay &&

                        <div className="empty-state-body empty-record"  >
                            <div className="empty-state__message">

                                <p className="form-check font-size-16">Loading...</p>
                            </div>
                        </div>

                    }

                    {isPopupOpen && (
                        <div
                            style={{
                                position: "fixed",
                                top: 0,
                                left: 0,
                                width: "100vw",
                                height: "100vh",
                                backgroundColor: "rgba(0, 0, 0, 0.5)",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                zIndex: 999,
                            }}
                            onClick={() => setPopupOpen(false)}
                        >
                            <div className="popup_wrp"
                                style={{
                                    position: "relative",
                                    background: "white",
                                    padding: "10px",
                                    borderRadius: "10px",
                                    maxWidth: "90vw",
                                     maxHeight: "90vh",
                                    
                                }}
                                onClick={(e) => e.stopPropagation()}
                            >
                                {/* Close Button */}
                                <button
                                    style={{
                                        position: "absolute",
                                        top: 10,
                                        right: 10,
                                        background: "white",
                                        color: "#000",
                                        border: "none",
                                       
                                        cursor: "pointer",
                                        borderRadius: "5px",
                                    }}
                                    onClick={() => setPopupOpen(false)}
                                >
                                   <span className="material-symbols-outlined">
close
</span>
                                </button>

                                {/* Zoomable Image */}
                                <TransformWrapper ref={transformRef} initialScale={1}>
                                    <div style={{ textAlign: "left", marginBottom: "10px" }}>
                                        <button onClick={() => transformRef.current.zoomIn()} className="btnzoom" ><span className="material-symbols-outlined"> add </span></button> 
                                        <button onClick={() => transformRef.current.zoomOut()} className="btnzoom"><span class="material-symbols-outlined"> remove </span></button>
                                        <button onClick={() => transformRef.current.resetTransform()} className="btnzoom"><span class="material-symbols-outlined"> refresh </span></button>
                                    </div>
                                    
                                    <TransformComponent>
                                        
                                            
                                        {isPopupLoading && <div style={{ width: "400px", height: "400px" }}><Loader /> </div>}

                                            <LazyLoadImage
                                                src={popupImage + `?auto=compress,format`}
                                                effect="blur"
                                                onLoad={() => setPopupLoading(false)}
                                                style={{ width: "100%", borderRadius: "10px" }}
                                            />
                                        {/* <img
                                            src={popupImage+`?auto=compress,format`}
                                            style={{ maxWidth: "100%", maxHeight: "80vh", borderRadius: "10px" }}
                                        /> */}
                                    </TransformComponent>
                                </TransformWrapper>
                            </div>
                        </div>
                    )}

                    {qdisplay == true && questions?.length == 0 &&

                        <div className="empty-state-body empty-record"  >
                            <div className="empty-state__message">
                                <span className="material-icons">summarize</span>
                                <p className="form-check font-size-16">No questions found
                                    <br />
                                    <button type="submit" className="btn1 btn-danger btn submit_buuton" onClick={(e) => onCancel(e)}>Back to Home</button>
                                </p>
                            </div> </div>

                    }

                    {errorMessage != " " && <h6 className="error mb-3">{errorMessage}</h6>}

                    {questions?.length > 0 &&
                        <div className="btns">
                            {/* <button type="submit" disabled={selected && Object.keys(selected).length > 0 ? false : true} className=" vs_btn mr-10" onClick={(e) => handleSubmit(e)}>Submit</button>

                          <button type="submit" disabled={selected && Object.keys(selected).length > 0 ? false : true} className="border_btn mr-10" onClick={(e) => onReset(e)}>Reset</button> */}

                            <button type="submit" className=" vs_btn mr-10" onClick={(e) => handleSubmit(e)}>Submit</button>

                            <button type="submit" className="border_btn mr-10" onClick={(e) => onReset(e)}>Reset</button>

                            <button type="submit" className="border_btn mr-10" onClick={(e) => onCancel(e)}>Cancel</button>
                        </div>
                    }


                    <SweetAlert show={success}
                        custom
                        confirmBtnText="ok"
                        confirmBtnBsStyle="primary"
                        title={"Quiz Submitted successfully"}
                        onConfirm={e => onConfirm()}
                    >
                    </SweetAlert>

                    <SweetAlert show={deletepopup}
                        warning
                        showCancel
                        confirmBtnText="Yes"
                        cancelBtnText="Cancel"
                        confirmBtnBsStyle="danger"
                        cancelBtnBsStyle="default"
                        title="Are you sure to cancel the Quiz?"
                        focusCancelBtn
                        onConfirm={e => onCancelConfirm()}
                        onCancel={e => onCancelReject()}
                    >
                    </SweetAlert>

                    <SweetAlert show={resetpopup}
                        warning
                        showCancel
                        confirmBtnText="Yes"
                        cancelBtnText="Cancel"
                        confirmBtnBsStyle="danger"
                        cancelBtnBsStyle="default"
                        title="Are you sure to reset the Quiz?"
                        focusCancelBtn
                        onConfirm={e => onResetConfirm()}
                        onCancel={e => onResetReject()}
                    >
                    </SweetAlert>
                    <SweetAlert show={handleBackPopup}
                        warning
                        showCancel
                        confirmBtnText="Yes"
                        cancelBtnText="Cancel"
                        confirmBtnBsStyle="danger"
                        cancelBtnBsStyle="default"
                        title="Are you sure you want to go to the back?"
                        focusCancelBtn
                        onConfirm={e => onBackConfirm()}
                        onCancel={e => onBackReject()}
                    >
                    </SweetAlert>
                    <Modal className="modal result-popup fade quiz_img_popup  transaction-detailModal" show={popup} onHide={handleClosePopup} backdrop="static">
                        <Modal.Header closeButton>
                            <Modal.Title>Image</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>



                            <div className="popup_img">
                                <img src={imageCloudfront + img} />
                            </div>




                        </Modal.Body>

                    </Modal>


                </div>
            </div>
            <Footer />
        </main>
    );
};

export default Quiz;
